import React from "react";
import { connect } from "react-redux";
import { isProduction } from "config";

import { AppShape } from "@eave/shared/types/api";
import { validCurrencyInputsOnly } from "@eave/shared/utils/numbers";

import { CarbonInputGenerationParams } from "web_modules/shared/carbon-types";
import WorksheetTable from "web_modules/shared/carbon/Worksheets/WorksheetTable";
import {
  emptyValuesToNull,
  dashToNull,
  yesNoStringsToBooleans,
} from "web_modules/shared/carbon/Worksheets/helpers";

import { loadApp } from "underwriter_dashboard/actions";
import { ENUM, WorksheetName, WS_NAME } from "underwriter_dashboard/shared/WorksheetEditor/wsDefs";

import { loadAdjustments, adjustmentsHeaderData, adjustmentToRow } from "./shared";

const Adjustments = ({ app, loadApp }: { app: AppShape; loadApp: Function }) => {
  const modalFields = (): CarbonInputGenerationParams[] => {
    const fields = [
      {
        name: "description",
        type: "text",
        label: "Description",
        placeholder: "",
        prepareForAPI: emptyValuesToNull,
      },
      {
        name: "paid_to_paid_by",
        type: "select",
        label: "Paid To / Paid By",
        options: ["-", ...ENUM.ADJUSTMENT_ITEM],
        prepareForAPI: dashToNull,
      },
      {
        name: "final_le_amount",
        type: "money",
        label: "Final LE amount ($)",
        beforeHandle: validCurrencyInputsOnly,
        prepareForAPI: emptyValuesToNull,
      },
      {
        name: "cd_amount",
        type: "money",
        label: "CD amount ($)",
        beforeHandle: validCurrencyInputsOnly,
        prepareForAPI: emptyValuesToNull,
      },
      {
        name: "verified",
        type: "select",
        label: "Verified",
        options: ["-", "Yes", "No"],
        prepareForAPI: yesNoStringsToBooleans,
      },
    ];

    return fields.filter(Boolean);
  };

  return (
    <WorksheetTable
      title="Adjustments"
      app={app}
      loadApp={loadApp}
      headerData={adjustmentsHeaderData}
      enableOverflowFeeDuplication
      modalFields={modalFields}
      wsName={WS_NAME.ADJUSTMENTS as WorksheetName}
      wsRecordName={WS_NAME.ADJUSTMENT as WorksheetName}
      wsSliceName="items"
      worksheetToRow={adjustmentToRow}
      worksheetToFormState={loadAdjustments}
    />
  );
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  app: ownProps.app,
  loadApp: appID => {
    loadApp(dispatch, appID);
  },
});

export default connect(null, mapDispatchToProps)(Adjustments);
